import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  availabilityTextFieldParent: {
    minWidth: 150,
  },
  availabilityFilterLabel: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 40,
    float: 'left',
    marginBottom: 0,
    backgroundColor: '#fafafa',
    minWidth: 158,
  },
  searchButtonPopover: {
    padding: '7px',
    transform: 'translate(-8px, -16px)!important',
    width: '320px',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
  buttonApply: {
    height: '45px',
    textTransform: 'none',
    fontSize: 20,
  },
  formControlRightFilters: {
    margin: theme.spacing(1),
  },
  popoverLabelText: {
    backgroundColor: '#F8F8F8',
    paddingLeft: 3,
    paddingRight: 3,
    borderRadius: 25
  },
  popoverLabelTextEllipsis:{
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    width: '10ch'
  }
  
}));

export default styles;
